module.exports = __webpack_public_path__ + "BannerSecundario_DAS.jpg?7bb70084fbf33400e732ae90b7e88e4d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/BannerSecundario_DAS.jpg
// module id = 203
// module chunks = 0